export default __webpack_public_path__ + "static/media/TSchedule1.f837aeef.png";